import { useContext, useState } from "react";
import { formatAmount, formatDate } from "../../../app-constants";
import appStyles from "../../../App.module.css";
import { IPortuguesePurchasePathContext } from "../../config/interface";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import PPPackageDisplayName from "../page/PPPPackageDisplayName";

function PPOrderSummary() {
  const { quoteData, order, quoteResult } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;

  const [showTripSummary, setShowTripSummary] = useState<boolean>(true);

  const tax: number = order?.tax || 0;
  const total: number = order?.total || 0;

  return (
    <div className={`${appStyles.tripSummary}  ${showTripSummary ? appStyles.tripSummaryVisible : ""}`}>
      <div
        className={`${appStyles.tripSummaryTitle} ${appStyles.tripSummaryAlwaysOpen}`}
        onClick={(e) => {
          setShowTripSummary(showTripSummary);
        }}
      >
        <h4>Order Summary</h4>
      </div>
      <div className={`${appStyles.tripSummaryContent}`}>
        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>Plan</div>
          <div className={appStyles.tripSummaryValue}>Single Trip</div>
        </div>
        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>Number of travellers</div>
          <div className={appStyles.tripSummaryValue}>{order?.items?.length || 0}</div>
        </div>
        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>Cover Period</div>
          <div className={appStyles.tripSummaryValue}>
            {`${formatDate(quoteData.start_date)} to ${formatDate(quoteData.end_date)}`}
          </div>
        </div>

        <div className={`${appStyles.tripSummaryOrderBreakdown}`}>
          {quoteResult?.details.map((result: any, index: number) => {
            return (
              <div key={index} className={`${appStyles.tripSummaryRow}`}>
                <div className={`${appStyles.tripSummaryLabel}`}>
                  <PPPackageDisplayName packageName={result.type} />
                </div>
                <div className={appStyles.tripSummaryValue}>
                  {formatAmount(result.amount || 0, "US", quoteData.currency?.value || "EUR")}
                </div>
              </div>
            );
          })}

          <div className={`${appStyles.tripSummaryRow}`}>
            <div className={appStyles.tripSummaryLabel}>Tax</div>
            <div className={appStyles.tripSummaryValue}>
              {formatAmount(tax, "US", quoteData.currency?.value || "EUR")}
            </div>
          </div>

          <div className={`${appStyles.tripSummaryRow} ${appStyles.tripSummaryOrderTotal}`}>
            <div className={appStyles.tripSummaryLabel}>Total</div>
            <div className={`${appStyles.tripSummaryValue} ${appStyles.colorPrimary}`}>
              {formatAmount(total, "US", quoteData.currency?.value || "EUR")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PPOrderSummary;
